// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choice-button-group {\n    margin-bottom: 1rem;\n}\np.question-text {\n    margin-bottom: .5rem;\n    font-weight: bold;\n}\n.dropdown-item {\n    width: 400px;\n    white-space: normal;\n    word-break: break-word;\n}\n.form-control {\n    width: 400px;\n    white-space: normal;\n    word-break: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
